import { apiService, handleResponse } from '@/services/apiService';

export class UserRepository {
    async login(credentials: { email: string; password: string }) {
        const response = await apiService.post(`/login`, credentials);
        return handleResponse(response);
    }
    async logout() {
        const response = await apiService.post(`/logout`);
        return handleResponse(response);
    }

    async getUser() {
        const response = await apiService.get(`/v1/user`);
        return handleResponse(response);
    }
}
